module.exports = __webpack_public_path__ + "img/fasttrack_mou_allow.5bb0db55.png";